<template>
<div>
    <div class="container">
        <div class="d-flex flex-row-reverse">
            <div class="mt-5 mb-4 btn-home">
                <button type="button" class="btn text-white" @click="returnHome">
                    <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
            </div>
        </div>
        <div id="div-modal-anular" class="w-100">
            <div id="div-anular" class="card w-100">
                <div class="card-header text-white h4 bg-main text-center">
                    <strong>FARMACIA</strong>
                </div>
                <div class="card-body w-100">
                    <cTable :columns="columns" :data="data" @openmodal="openmodal" @deleteData="deleteData" />
                </div>
            </div>
        </div>
        <cModalFarmaciaVue :dataCategoria="dataCategoria" :dataBrands="dataBrands" :payload="modal.payload" @Datadetail="Datadetail" :title="modal.title" :boo_modal="modal.modal_form" @closeModal="closeModal" :num="modal.num" />
        <SweetAlert :swal="swal" ref="SweetAlert" @deleteDataDetail="deleteDataDetail" />
    </div>
</div>
</template>

<script>
import cTable from '../shared/Table/cTable.vue'
import {
    mapActions
} from 'vuex'
import cModalFarmaciaVue from './Modals/cModalFarmacia.vue'
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
export default {
    name: 'c-mantenimiento-farmacia',
    data() {
        return {
            swal: null,
            columns: [
                'N°',
                'NOMBRE',
                'CATEGORIA',
                'MARCA',
                'MOLECULA',
                'NOMBRE COMERCIAL',
                'PRESENTACIÓN',
                'CONCENTRACIÓN',
                'DESCUENTO',
                'LOTE',
                'FECHA DE VENCIMIENTO',
                'VENTA S/IGV',
                'VENTA C/IGV',
                'COSTO S/IGV',
                'COSTO C/IGV',
                'ESTADO',
                'ACCIONES'
            ],
            data: [],
            dataBrands: [],
            dataCategoria:[],
            modal: {
                title: '',
                modal_form: false,
                num: null,
                payload: {},
            }
        }
    },
    components: {
        cTable,
        cModalFarmaciaVue,
        SweetAlert
    },
    created() {
        this.getData();
    },
    methods: {
        ...mapActions(['get', 'post']),
        getData: function () {
            this.get({
                    url: this.$store.getters.get__url + "/Maintainer/index/5",
                    token: this.$store.getters.get__token,
                }).then(response => {
                    const dataArray = response.data;
                    dataArray.forEach(item => {
                        this.calculatePricesIGV(item);
                    });
                    this.data = dataArray;
                    this.getProvedores();
                    this.getCategorias();
                })
                .catch(error => {
                    console.log(error);
                })
        },
        getProvedores: function () {
            this.get({
                    url: this.$store.getters.get__url + "/Maintainer/indexBrands",
                    token: this.$store.getters.get__token,
                }).then(response => {
                    this.dataBrands = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },
        getCategorias : function (){
            this.get({
                    url: this.$store.getters.get__url + "/Maintainer/indexCategorias",
                    token: this.$store.getters.get__token,
                }).then(response => {
                    this.dataCategoria = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },
        Datadetail: function (payload_detail, num_detail) {
            if (num_detail == 0) {
                payload_detail.action = 'c';
            } else {
                payload_detail.action = 'u';
            }
            this.mtdMaintenanceDatadetail(payload_detail);
        },
        mtdMaintenanceDatadetail: function (payload_detail) {
            this.post({
                    url: this.$store.getters.get__url + "/Maintainer/Pharmacy",
                    token: this.$store.getters.get__token,
                    params: payload_detail,
                })
                .then(response => {
                    if (payload_detail.action != 'd') {
                        this.$refs.SweetAlert.showSuccess(response.message);
                        this.closeModal()
                    }
                    this.getData();
                })
                .catch(error => {
                    console.log(error);
                })
        },
        deleteData: function (payload_detail) {
            payload_detail.action = 'd';
            this.$refs.SweetAlert.showDelete(payload_detail, 'deleteDataDetail');

        },
        deleteDataDetail: function (payload_detail) {
            this.mtdMaintenanceDatadetail(payload_detail)
        },
        returnHome() {
            this.$emit('mtdChangePage', 'home')
        },
        openmodal: function (num, payload) {
            console.log(num),
            console.log(payload);
            if (num !== 0) {
                if (payload.brand_id == null) {
                    payload.brand_id = '';
                    payload.molecule = '';
                    payload.comercial = '';
                    payload.presentacion ='';
                    payload.concentration ='';
                }
            }
            console.log(payload);
            this.modal.title = (num == 0) ? 'Registrar Farmacia' : 'Editar Farmacia ';
            this.modal.modal_form = true;
            this.modal.num = num;
            this.modal.payload = payload;

        },
        closeModal: function () {
            this.modal = {
                title: '',
                modal_form: false,
                num: null,
                payload: {},
            }

        },
        calculatePricesIGV: function (item) {
            const priceCost = parseFloat(item.price_cost);
            const priceSale = parseFloat(item.price_sale);
            const igvPercentage = 1.18;
            const priceCostIGV = priceCost * igvPercentage;
            const priceSaleIGV = priceSale * igvPercentage;
            item.price_cost_igv = priceCostIGV.toFixed(2);
            item.price_sale_igv = priceSaleIGV.toFixed(2);
        },
    }
}
</script>
